import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { noCoordinatesLocationSelector } from "../../../reducers/matrixProfile/selectors";

import { Modal } from "../Modal";
import { NoCoordinatesLocationActions } from "./NoCoordinatesLocationActions";
import { NoCoordinatesLocationContent } from "./NoCoordinatesLocationContent";
import { setNoCoordinatesLocation } from "../../../reducers/matrixProfile/thunkActions";

export const NoCoordinatesLocation = memo(() => {
  const dispatch = useDispatch();
  const noCoordinatesLocation = useSelector(noCoordinatesLocationSelector);

  const onClose = () => dispatch(setNoCoordinatesLocation(null));

  return (
    <Modal
      open={!!noCoordinatesLocation}
      title={"No Coordinates Location"}
      onClose={onClose}
      maxWidth={"xs"}
      content={<NoCoordinatesLocationContent {...noCoordinatesLocation} />}
      actions={<NoCoordinatesLocationActions onContinue={onClose} />}
    />
  );
});
